/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from "@utils/loadable";

export const QLoginPage = lazyLoad(
  () => import("./index"),
  (module) => module.QLoginPage
);
